import { AddIcon, CloseIcon } from "@chakra-ui/icons";
import { Button, Divider, HStack, IconButton, VStack, Text, Card, CardBody, Input, Select, Stack } from "@chakra-ui/react";
import React from "react";
import { TeamRoles } from "../clients/data-service";
import { GroupBy, OrderBy } from "../utilities/DataTools";
import { DraftImageSubject } from "../utilities/ImageSubjectUtilities";
import { PeopleUpdater } from "./PeopleUpdater";

class PAProps {
    person: DraftImageSubject;
    peopleUpdater: PeopleUpdater;
}

class PersonAnnotation extends React.Component<PAProps> {
    render(): React.ReactNode {
        const person = this.props.person;
        return (<>
            <Card minW={100}>
                <CardBody padding={2}>
                    <HStack>
                        <Stack spacing={1}>
                            {/* <Flex>
                                <Text fontSize='xs'>row:{this.props.person.row}, col:{this.props.person.column}</Text>
                                <Spacer/>
                                <IconButton size='xs' icon={<CloseIcon />} aria-label={'Remove Person'}/>
                            </Flex> */}

                            <Input size='xs' type="text" placeholder="Name" name="name" autoComplete="off" value={person.name ?? ""} onChange={event => this.props.peopleUpdater.updateName(person, event.target.value)} />
                            <Select size='xs' name="role" placeholder="Role" value={person.role}  onChange={event => this.props.peopleUpdater.updateRole(person, event.target.value)}>
                                {TeamRoles().map(role => <option key={role.Key} value={role.Key}>{role.Selection}</option>)}
                            </Select>
                        </Stack>
                        <VStack>
                            <IconButton size='xs' icon={<CloseIcon />} aria-label={'Remove Person'} onClick={()=> this.props.peopleUpdater.remove(person)}/>
                        </VStack>
                    </HStack>
                </CardBody>
            </Card>
        </>);
    }
}


class PeopleRowState {
    rowIndex: number; 
    people: DraftImageSubject[];
    isTopRow: boolean;
    peopleUpdater: PeopleUpdater
}
class PeopleRow extends React.Component<PeopleRowState> {
    render() {
  
        const rowIndex = this.props.rowIndex;
        const isTopRow = this.props.isTopRow;
        const people = this.props.people;

        let rowLabel = `Row ${rowIndex}`;
        if (isTopRow)
        {
            rowLabel = rowLabel + " (Back)";
        }
        if (rowIndex === 1)
        {
            rowLabel = rowLabel + " (Front)";
        }
        if (rowIndex === 0)
        {
            rowLabel = "Other"
        }
        if (rowIndex === -1)
        {
            rowLabel = "Absent"
        }

        return (<>
            <HStack>
                <Text>{rowLabel}</Text>
                {OrderBy(people, p=>p.column).map(p => <PersonAnnotation key={`Person_id_${p.id}_r${p.row}_c${p.column}`} person={p} peopleUpdater={this.props.peopleUpdater}></PersonAnnotation>)}
                <IconButton icon={<AddIcon />} aria-label={'Add Person To Row'} onClick={() => this.props.peopleUpdater.addToRow(rowIndex)}/>
            </HStack>
        </>);
    }
}

export class ImageSubjectEntry extends React.Component<{people: Array<DraftImageSubject>, peopleUpdater: PeopleUpdater}> {

    render(): React.ReactNode {

        const allRowData = Array.from(GroupBy(this.props.people, p => p.row).entries());
    
        const normalRows = allRowData.filter(r => r[0] > 0).sort((a,b) => b[0] - a[0]);
        const maxRow = allRowData.reduce((prev,cur) => cur[0] > prev[0] ? cur : prev, [0,[]])[0];

        const peopleUpdater = this.props.peopleUpdater;
        const buildRow = function(singleRowData:[number, DraftImageSubject[]]) {
            const rowIndex = singleRowData[0];
            const rowPeople = singleRowData[1];
            return (<PeopleRow key={`row_${rowIndex}`} rowIndex={rowIndex} people={rowPeople} peopleUpdater={peopleUpdater} isTopRow={rowIndex === maxRow} />);
        }

        const findRowOrEmpty = function(rowIndex:number) :[number, DraftImageSubject[]] {
            const row = allRowData.find(r => r[0] === rowIndex);
            return row ?? [rowIndex, []];
        }

        return (<>
            <VStack>
                <Button size='xs' leftIcon={<AddIcon />} aria-label={'Add Row At Back'} onClick={() => this.props.peopleUpdater.addRowBack()}>Add Row At Back</Button>
                {normalRows.map(rd => buildRow(rd))}
                <Button size='xs' leftIcon={<AddIcon />} aria-label={'Add Row At Back'} onClick={() => this.props.peopleUpdater.addRowFront()}>Add Row At Front</Button>
                <Divider></Divider>
                {buildRow(findRowOrEmpty(0))}
                {buildRow(findRowOrEmpty(-1))}
                <Divider></Divider>
            </VStack>
        </>);
    }
    
}